import FormInputText from './../Partials/FormInputText';
import FormInputTextArea from './../Partials/FormInputTextArea';
import MetaColumn from './MetaColumn';
import GeneralForm from './../Forms/GeneralForm';

const AboutUsPageBuilder = {
    component: GeneralForm,
    options: {
        columns: {
            meta: MetaColumn,
            contents: [
                {
                    field: "heading",
                    partial: {
                        handler: FormInputText,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "heading");
                            },
                            required: true,
                            label: "سر صفحه"
                        }
                    }
                },
                {
                    field: "description",
                    partial: {
                        handler: FormInputTextArea,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "description");
                            },
                            required: true,
                            label: "توضیحات",
                            textSize: 7
                        }
                    }
                },
                {
                    field: "features",
                    partial: {
                        handler: (props)=> {
                            return props.formHandler.buildArrayInputs("contents", "features", "امکانات", {
                                icon: {
                                    label: "آیکن",
                                    props: {
                                        style:{
                                            direction: "ltr"
                                        }
                                    }
                                },
                                content: {
                                    label: "محتوی",
                                },

                            }, false, false)
                        }
                    }
                }
            ]
        }
    }
};

export default AboutUsPageBuilder;


// WEBPACK FOOTER //
// ./src/containers/Pages/Builders/AboutUsPageBuilder.js